import { createAction } from '@reduxjs/toolkit';
import * as actionPrepare from './assets.prepare';

export const setDefinedAssets = createAction('assets/set_defined_assets', actionPrepare.setAssets);
export const setUserInputs = createAction('assets/set_user_inputs', actionPrepare.setAssets);
